// Full-document render of the embeddable nav-only fragment (NavIFrameView).
// PageSkeleton renders the site header but omits the footer and the <main>
// wrapper, then appends the iframe-resizer scripts. OneTrust/GTM stay (the
// legacy nav-iframe's {% block onetrust %}/{% block allcontent %} overrides
// matched no block in stearns.html and were no-ops); only the footer + zendesk
// were blanked (zendesk via the view's chat_widget_enabled=False).
import React from "react";

import { Context, templates } from "@reactivated";

import { useSSRNonce } from "@thelabnyc/thelabui/src/hooks/useSSRNonce";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.NavIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    const nonce = useSSRNonce();
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            footer={false}
            wrapMain={false}
        >
            {/* iFrameResizer config must be set before the contentWindow script
                loads. The legacy nav-iframe used heightCalculationMethod "max". */}
            <script
                nonce={nonce}
                dangerouslySetInnerHTML={{
                    __html: `window.iFrameResizer = { heightCalculationMethod: "max" };`,
                }}
            />
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
                nonce={nonce}
                suppressHydrationWarning={true}
            />
        </PageSkeleton>
    );
};
